import { Box, Checkbox as Checkbox$1, CounterLabel as CounterLabel$1, Flash as Flash$1, sx, Header as Header$1, LinkButton as LinkButton$1, RadioGroup as RadioGroup$1, RelativeTime as RelativeTime$1, SegmentedControl as SegmentedControl$1, Spinner as Spinner$1, StateLabel as StateLabel$1, SubNav as SubNav$1, Timeline as Timeline$1, ToggleSwitch as ToggleSwitch$1, Truncate as Truncate$1, UnderlineNav as UnderlineNav$1 } from '@primer/react';
export { ActionList, ActionMenu, Autocomplete, Avatar, Box, Breadcrumbs, Button, CheckboxGroup, CircleBadge, Details, Dialog, FormControl, Heading, IconButton, Label, Link, NavList, Overlay, PageLayout, ProgressBar, Select, Text, TextInput, Textarea, ThemeProvider, Token, Tooltip, merge, sx, theme, themeGet, useColorSchemeVar, useTheme } from '@primer/react';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
export { P as PageHeader } from './PageHeader-Bvki2mbE.js';

const Checkbox = /*#__PURE__*/forwardRef(function Checkbox(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Checkbox$1,
    ref: ref,
    ...props
  });
});

const CounterLabel = /*#__PURE__*/forwardRef(function CounterLabel(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: CounterLabel$1,
    ref: ref,
    ...props
  });
});

const Flash = styled(Flash$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Flash",
  componentId: "sc-413izo-0"
})(["", ""], sx);

const HeaderImpl = /*#__PURE__*/forwardRef(function Header(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Header$1,
    ref: ref,
    ...props
  });
});
const HeaderItem = /*#__PURE__*/forwardRef(function HeaderItem(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Header$1.Item,
    ref: ref,
    ...props
  });
});
const HeaderLink = /*#__PURE__*/forwardRef(function HeaderLink(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Header$1.Link,
    ref: ref,
    ...props
  });
});
const Header = Object.assign(HeaderImpl, {
  Item: HeaderItem,
  Link: HeaderLink
});

const LinkButton = styled(LinkButton$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "LinkButton",
  componentId: "sc-1v6zkmg-0"
})(["", ""], sx);

const RadioGroupImpl = props => {
  return /*#__PURE__*/jsx(Box, {
    as: RadioGroup$1,
    ...props
  });
};

// Define local types based on the internal component props

const CheckboxOrRadioGroupLabel = props => {
  return /*#__PURE__*/jsx(Box, {
    as: RadioGroup$1.Label,
    ...props
  });
};
const CheckboxOrRadioGroupCaption = props => {
  return /*#__PURE__*/jsx(Box, {
    as: RadioGroup$1.Caption,
    ...props
  });
};
const CheckboxOrRadioGroupValidation = props => {
  return /*#__PURE__*/jsx(Box, {
    as: RadioGroup$1.Validation,
    ...props
  });
};
const RadioGroup = Object.assign(RadioGroupImpl, {
  Label: CheckboxOrRadioGroupLabel,
  Caption: CheckboxOrRadioGroupCaption,
  Validation: CheckboxOrRadioGroupValidation
});

function RelativeTime(props) {
  // @ts-expect-error the types for Box are not correctly inferred here
  return /*#__PURE__*/jsx(Box, {
    as: RelativeTime$1,
    ...props
  });
}

const SegmentedControlButton = props => {
  return /*#__PURE__*/jsx(Box, {
    as: SegmentedControl$1.Button,
    ...props
  });
};
const SegmentedControlIconButton = props => {
  return /*#__PURE__*/jsx(Box, {
    as: SegmentedControl$1.IconButton,
    ...props
  });
};
const SegmentedControlImpl = props => {
  return /*#__PURE__*/jsx(Box, {
    as: SegmentedControl$1,
    ...props
  });
};
const SegmentedControl = Object.assign(SegmentedControlImpl, {
  Button: SegmentedControlButton,
  IconButton: SegmentedControlIconButton
});

function Spinner(props) {
  return /*#__PURE__*/jsx(Box, {
    as: Spinner$1,
    ...props
  });
}

const StateLabel = /*#__PURE__*/forwardRef(function StateLabel(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: StateLabel$1,
    ref: ref,
    ...props
  });
});

const SubNavImpl = /*#__PURE__*/forwardRef(function SubNav(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: SubNav$1,
    ref: ref,
    ...props
  });
});
const SubNavLink = /*#__PURE__*/forwardRef(function SubNavLink(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: SubNav$1.Link,
    ref: ref,
    ...props
  });
});
const SubNav = Object.assign(SubNavImpl, {
  Link: SubNavLink
});

const TimelineImpl = /*#__PURE__*/forwardRef(function Timeline(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Timeline$1,
    ref: ref,
    ...props
  });
});
const TimelineItem = /*#__PURE__*/forwardRef(function TimelineItem(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Timeline$1.Item,
    ref: ref,
    ...props
  });
});
function TimelineBadge(props) {
  return /*#__PURE__*/jsx(Box, {
    as: Timeline$1.Badge,
    ...props
  });
}
const TimelineBody = /*#__PURE__*/forwardRef(function TimelineBody(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Timeline$1.Body,
    ref: ref,
    ...props
  });
});
const TimelineBreak = /*#__PURE__*/forwardRef(function TimelineBreak(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Timeline$1.Break,
    ref: ref,
    ...props
  });
});
const Timeline = Object.assign(TimelineImpl, {
  Item: TimelineItem,
  Badge: TimelineBadge,
  Body: TimelineBody,
  Break: TimelineBreak
});

const ToggleSwitch = /*#__PURE__*/forwardRef(function ToggleSwitch(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: ToggleSwitch$1,
    ref: ref,
    ...props
  });
});

const Truncate = styled(Truncate$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Truncate",
  componentId: "sc-x3i4it-0"
})(["", ""], sx);

const UnderlineNavImpl = /*#__PURE__*/forwardRef(function UnderlineNav(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: UnderlineNav$1,
    ref: ref,
    ...props
  });
});
const UnderlineNavItem = styled(UnderlineNav$1.Item).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "UnderlineNav__UnderlineNavItem",
  componentId: "sc-dx6br2-0"
})(["", ""], sx);
const UnderlineNav = Object.assign(UnderlineNavImpl, {
  Item: UnderlineNavItem
});

export { Checkbox, CounterLabel, Flash, Header, LinkButton, RadioGroup, RelativeTime, SegmentedControl, Spinner, StateLabel, SubNav, Timeline, ToggleSwitch, Truncate, UnderlineNav };
